import { KonvaEventObject } from "konva/lib/Node";
import { Vector2d } from "konva/lib/types";
import { useEffect, useRef, useState } from "react";
import { Stage, Layer, Image } from "react-konva";

type PropsType = {
  imgSrc: string;
  imgBgRmSrc: string;
};

function EditBgRm({ imgSrc, imgBgRmSrc }: PropsType) {
  const imgSize = window.innerHeight * 0.6;

  const stageRef = useRef<any>(null);
  const lastPosition = useRef<Vector2d | null>(null);

  const [canvas, setCanvas] = useState<HTMLCanvasElement | undefined>(
    undefined
  );

  useEffect(() => {
    localStorage.removeItem("edited-bg-rm-img");

    const _canvas = document.createElement("canvas");
    const _canvasPattern = document.createElement("canvas");
    _canvas.width = imgSize;
    _canvas.height = imgSize;
    _canvasPattern.width = imgSize;
    _canvasPattern.height = imgSize;

    const _img = new window.Image();
    _img.crossOrigin = "Anonymous";
    const _imgBgRm = new window.Image();
    _imgBgRm.crossOrigin = "Anonymous";

    _img.onload = () => {
      _imgBgRm.src = imgBgRmSrc;
    };
    _imgBgRm.onload = () => {
      const ctx = _canvas.getContext("2d");
      const ctxPattern = _canvasPattern.getContext("2d");
      if (!!ctx && !!ctxPattern) {
        ctx.drawImage(_imgBgRm, 0, 0, imgSize, imgSize);
        ctxPattern.drawImage(_img, 0, 0, imgSize, imgSize);

        ctx.globalCompositeOperation = "destination-over";
        const pattern = ctx.createPattern(_canvasPattern, "no-repeat");
        if (!!pattern) ctx.strokeStyle = pattern;
      }

      setCanvas(_canvas);
    };

    _img.src = imgSrc;
  }, [imgSrc, imgBgRmSrc, imgSize]);

  if (!canvas) return <></>;

  const onMouseDown = (ev: KonvaEventObject<MouseEvent | TouchEvent>) => {
    const stage = ev.target.getStage();
    lastPosition.current = stage?.getPointerPosition() || null;
  };
  const onMouseUp = () => {
    lastPosition.current = null;
  };
  const onMouseOut = async () => {
    if (stageRef.current != null) {
      const uri = stageRef.current.toDataURL();
      localStorage.setItem("edited-bg-rm-img", uri);
    }
  };
  const onMouseMove = (ev: KonvaEventObject<MouseEvent | TouchEvent>) => {
    if (!lastPosition.current) return;

    const stage = ev.target.getStage();
    const layer = ev.target.getLayer();
    if (!stage || !layer) return;

    const context = canvas.getContext("2d");
    if (!context) return;

    context.fill();
    context.lineJoin = "round";
    context.lineWidth = 20;
    context.beginPath();

    let localPos = {
      x: lastPosition.current.x.valueOf() - 0,
      y: lastPosition.current.y.valueOf() - 0,
    };
    context.moveTo(localPos.x, localPos.y);

    const pos = stage.getPointerPosition();
    if (!pos) return;
    localPos = {
      x: pos.x - 0,
      y: pos.y - 0,
    };
    context.lineTo(localPos.x, localPos.y);
    context.closePath();
    context.stroke();

    lastPosition.current = pos;
    layer.draw();
  };

  return (
    <Stage width={imgSize} height={imgSize}>
      <Layer ref={stageRef}>
        <Image
          image={canvas}
          x={0}
          y={0}
          width={imgSize}
          height={imgSize}
          onMouseDown={onMouseDown}
          onTouchStart={onMouseDown}
          onMouseMove={onMouseMove}
          onTouchMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseOut={onMouseOut}
          onTouchEnd={() => {
            onMouseUp();
            onMouseOut();
          }}
        />
      </Layer>
    </Stage>
  );
}

export default EditBgRm;
